var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeadphones = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 71.415 106.529"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 3688",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  fill: "#eae8e5",
  d: "m20.455 57.995 1.486-4.457c.742-2.229 5.2-7.429 5.2-7.429l8.913-8.913 12.629 2.229 2.228 12.628.582 4.417-7.268 14.9-4.457 5.942-20.056-11.141Z",
  "data-name": "Tracciato 3563"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eae8e5",
  d: "M63.16 31.339a14 14 0 0 0 .379 1.4 62 62 0 0 0 2.972 7.429l-3.716.742s.744 15.6-2.971 16.342-12.628-1.486-16.343-3.715-6.685-6.685-6.685-9.656a10.3 10.3 0 0 0-1.485-5.2l-2.229.743-2.229-17.085 25.257-8.17 8.17 2.228-1.485 4.457a40.7 40.7 0 0 0 .365 10.485",
  "data-name": "Tracciato 3564"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#726e68",
  d: "M21.942 53.536s12.628-.742 13.371-8.17-.743-7.429-1.486-8.915-2.972-5.941.743-8.17 6.685 4.456 6.685 4.456.2-10.478 3.714-11.885c3.715-1.484 13.371 0 13.371 0s15.916.522 12.628-12.628c-3.713-14.855-24.513-5.2-29.713-4.458s-16.872 2.455-20.8 5.943c-6.685 5.942-3.045 12.408.744 23.771 2.971 8.914.743 20.056.743 20.056",
  "data-name": "Tracciato 3565"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#726e68",
  d: "M21.942 53.536s12.628-.742 13.371-8.17-.743-7.429-1.486-8.915-2.972-5.941.743-8.17 6.685 4.456 6.685 4.456.2-10.478 3.714-11.885c3.715-1.484 13.371 0 13.371 0s15.916.522 12.628-12.628c-3.713-14.855-24.513-5.2-29.713-4.458s-16.872 2.455-20.8 5.943c-6.685 5.942-3.045 12.408.744 23.771 2.971 8.914.743 20.056.743 20.056",
  "data-name": "Tracciato 3566"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.426,
  cy: 4.426,
  r: 4.426,
  fill: "none",
  stroke: "#c1a42d",
  strokeMiterlimit: 10,
  strokeWidth: 0.599,
  "data-name": "Ellisse 477",
  transform: "translate(38.168 31.161)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.509,
  cy: 3.509,
  r: 3.509,
  fill: "none",
  stroke: "#c1a42d",
  strokeMiterlimit: 10,
  strokeWidth: 0.524,
  "data-name": "Ellisse 478",
  transform: "translate(39.085 32.077)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.592,
  cy: 2.592,
  r: 2.592,
  fill: "none",
  stroke: "#c1a42d",
  strokeMiterlimit: 10,
  strokeWidth: 0.449,
  "data-name": "Ellisse 479",
  transform: "translate(40.001 32.995)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c1a42d",
  "data-name": "Raggruppa 2234"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.851 30.552a2.4 2.4 0 0 0-.382-.912c-.154 1.43-.2 2.567-.211 2.952a2.37 2.37 0 0 0 .593-2.04",
  "data-name": "Tracciato 3567"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.905 36.115a8.5 8.5 0 0 1-1.628.144 1 1 0 0 0-.338 0 1.015 1.015 0 0 0 .175 2.014h.017a19 19 0 0 0 2.165-.114q-.155-1.027-.378-2.048Z",
  "data-name": "Tracciato 3568"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.665 30.626c-1.283.722-2.643 1.482-3.949 2.214l-4.076 2.284-.07.03a8.5 8.5 0 0 1-2.649.964q.222 1.02.379 2.048c.308-.036.629-.082.952-.141 1.181-.219 2.338-.833 2.946-.945a2 2 0 0 1 .356-.095 2.37 2.37 0 0 1 1.356.146l.056.024a4.3 4.3 0 0 0 1.5.2 2.4 2.4 0 0 0 .34-.089l1.2-.669c1.032-.575 1.948-1.084 2.282-1.272a7.24 7.24 0 0 1-.623-4.699",
  "data-name": "Tracciato 3569"
}), /*#__PURE__*/React.createElement("path", {
  d: "m45.599 35.728-.709-1.786-1.795-4.613-.048-.071a3.486 3.486 0 0 0-3.869-2.147 4 4 0 0 0-.431.108l-1.511.846a4.8 4.8 0 0 1 1.249.794 2.4 2.4 0 0 1 .6-.207 2.371 2.371 0 0 1 2.171 3.943c-.016.018-.035.029-.05.045a2.36 2.36 0 0 1-1.079.635l-.109.043a1.373 1.373 0 0 0-.771 1.783l1.077 2.718a1.377 1.377 0 0 0 1.785.771l2.718-1.077a1.38 1.38 0 0 0 .772-1.785",
  "data-name": "Tracciato 3570"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#a5a093",
  d: "M61.309 89.194c-5.2-7.429-17.084-17.828-17.084-17.828l-2.228 2.972-21.543-16.343S6.341 67.651 1.883 79.536c-.906 2.416-1.5 6.766-1.884 12.159a62.52 62.52 0 0 0 40.521 14.834 63 63 0 0 0 10.258-.839 64 64 0 0 0 2.328-.424 62.4 62.4 0 0 0 16.324-5.778c-2.69-3.162-5.783-6.953-8.121-10.294",
  "data-name": "Tracciato 3571"
}))));
export default SvgHeadphones;